<template>
    <div class='hidden' >
      <div class="bg t-center flex flex-column vcenter" :style="{position:opacity>=1.5?'relative':'fixed','margin-top':opacity>=1.5?'600px':'0px'}" >
        <img class='Partition1' :src="require('../../assets/product/partition/Partition_001.png')">
        <img :style="{opacity:opacity}" class='Partition2' :src="require('../../assets/product/partition/Partition_002.png')">
        <img class='mainText' :src="require('../../assets/product/partition/mainText.png')">
          
      </div>
      <div class='scaleImg'>
          <div class="row">
            <div :style="{position:'relative',transition:'all 0.2s',bottom:width>1200?'700px':'0'}">
                <img :src="require('../../assets/product/partition/scaleText.png')">
            </div>
            <img :style="{width:width + 'px',left:left + 'px',top:top + 'px' }" :src="require('../../assets/product/partition/scale.png')">
            <img :style="{bottom:width>=2000?width-1500+'px':'0',opacity:width>=2000?1:0, }" class='scaleNum' :src="require('../../assets/product/partition/scaleNum.png')">
          </div>
      </div>
      <div class="changeColor">
          <div class="row flex t-center">
              <img class='img1' :src="require('../../assets/product/partition/img1.png')">
              <img class='img2' :src="require('../../assets/product/partition/img2.png')">
          </div>
      </div>
      <div class="imgs">
          <div class="row flex vcenter">
              <img class='img3' :src="require('../../assets/product/partition/img3.png')">
              <div class='flex flex-column vcenter'>
                  <img class='img4' :src="require('../../assets/product/partition/img4.png')">
                  <img class='img1' :src="require('../../assets/product/partition/img1.png')">
              </div>
          </div>
          
      </div>
    <div class='bottom'>
      <div class="flex hcenter row">
          <div class="item t-center mx8 ">
              <img :src="require('../../assets/product/introduce1.png')">
              <!-- <p class='t-center m0'><el-button type='text ft15' @click='showDialog(201)'>超国标E1级环保</el-button></p> -->
          </div>
          <div class="py4 mx2"><el-divider direction='vertical' class='full-height'></el-divider></div>
          <div class="item t-center mx8 ">
              <img :src="require('../../assets/product/introduce2.png')">
              <!-- <p class='t-center m0'><el-button type='text ft15' @click='showDialog(202)'>A1级防火</el-button></p> -->
          </div>
          <div class="py4 mx2"><el-divider direction='vertical' class='full-height'></el-divider></div>
          <div class="item t-center mx8 ">
              <img :src="require('../../assets/product/introduce3.png')">
              <!-- <p class='t-center m0'><el-button type='text ft15' @click='showDialog(204)'>防水防潮</el-button></p> -->
          </div>
          <div class="py4 mx2"><el-divider direction='vertical' class='full-height'></el-divider></div>
          <div class="item t-center mx8 ">
              <img :src="require('../../assets/product/introduce5.png')">
              <!-- <p class='t-center m0'><el-button type='text ft15' @click='showDialog(205)'>耐磨耐刮痕</el-button></p> -->
          </div>
      </div>
  </div>

    </div>
</template>

<script>

export default {

    data(){
        return{
            width:1200,
            left:-100,
            top:0,
            opacity:0,
            currentColor:1,
            changeColorUrl:"",
            changeLoading:false
        }
    },
    mounted() {
        window.addEventListener("scroll", this.handleScrollx,true);
    },
    methods: {
        handleScrollx(){
            this.opacity = window.pageYOffset/400;
            if(window.pageYOffset>2200){
                this.width = 1200 + (window.pageYOffset-2200)*2;
                this.left = (2200 - window.pageYOffset)-100;
                this.top = (window.pageYOffset-2200) * -1;
                if(window.pageYOffset>2800){
                    this.width = 1200 + (2800-2200)*2;
                    this.left = (2200 - 2800)-100;
                    this.top = (2800-2200) * -1;
                }
            }else{
                this.width = 1200;
                this.left = -100;
                this.top = 0;
            }
        }
      
    },
    //离开页面时销毁
    beforeDestroy(){
        window.removeEventListener("scroll",this.handleScrollx)
    }


}
</script>

<style lang='scss' scoped>

    .bg{
        width: 100%;
        height: 1225px;
        min-height: 100vh;
        background-color: #6A6A6A;
        top:45px;
        z-index: 1;
        // position: relative;
        .mainText{
            // margin-top:-360px;
            // margin-left:50px;
            position: absolute;
            top:630px;
            left:calc(50% - 473px);
            z-index:2;
        }
        .Partition1{
            z-index:0;
            position: absolute;
        }
        .Partition2{
            z-index:1;
            position: absolute;
            //transition: opacity 0.5s;
        }
    }
    .scaleImg{
        padding:206px 0;
        overflow: hidden;
        height: 1815px;
        .row{
            width: 800px;
            margin: 0 auto;
            div{
                width: 870px;
                span{
                    line-height: 38px;
                    letter-spacing: 1px;
                }
            }
            img{
                transition:all;
                position: relative;
            }
            .scaleNum{
                position: relative;
                left:-210px;
                bottom:0px;
                opacity: 0;
                transition:all 0.1s;
            }
        }
    }
    .changeColor{
        .row{
            width: 1200px;
            margin: 0 auto;
            .img1{
                width: 65%;
                margin-right: -230px;
            }
        }
    }
    .imgs{
        padding-top:206px;
        .row{
            width: 1200px;
            margin: 50px auto;
            div{
                .img4{
                    width: 50%;
                    margin-right: 150px;
                }
                .img1{
                    width: 110%;
                    margin-top:50px;
                }
            }
            .img3{
                width: 750px;
                margin-top:65px;
            }
        }
       
    }
    .bottom{
      border-top: 1px solid #DEDEDE;
      border-bottom: 1px solid #DEDEDE;
      .row{
          width: 60%;
          margin: 40px auto;
          .item{
            img{
              width: 90px;
            }
          }
      }
    }
</style>